export default __webpack_public_path__ + "static/media/phone-off.90310af5.svg";